import React from 'react';

const ImageBoxOne = ({imageOne, imageTwo, video})=> (
  <div className="img-box1">
    <div className="img-1">
      <img src={imageOne} alt="imgOne"/>
    </div>
  </div>
);

export default ImageBoxOne;
